<script lang="ts">
	import { Route } from 'tinro'
</script>

<Route fallback redirect="/">Fallback</Route>
